module.exports = __webpack_public_path__ + "svg/close.svg?b31bee7ce4bec4b72747aee738dda069";